import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { SessionService } from '@services/session.service';

export const publicGuard: CanActivateFn = (route, state) => {
  const authorized = !inject(SessionService).logged;

  if (authorized) {
    return true;
  } else {
    inject(Router).navigate(['/admin']);
    return false;
  }
};

export const publicGuardChild: CanActivateChildFn = (route, state) => {
  const authorized = !inject(SessionService).logged;

  if (authorized) {
    return true;
  } else {
    inject(Router).navigate(['/admin']);
    return false;
  }
};
